export class GroupForm{
    id  ;
    name ;
    formLanes  = new Array();
}
